/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeroBannerDto } from '../../models/hero-banner-dto';
import { UpdateHeroBannerDto } from '../../models/update-hero-banner-dto';

export interface HeroBannerControllerUpdateV1$Params {
  id: string;
      body: UpdateHeroBannerDto
}

export function heroBannerControllerUpdateV1(http: HttpClient, rootUrl: string, params: HeroBannerControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<HeroBannerDto>> {
  const rb = new RequestBuilder(rootUrl, heroBannerControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeroBannerDto>;
    })
  );
}

heroBannerControllerUpdateV1.PATH = '/api/v1/hero-banner/{id}';
